import buildHasuraProvider,
{
  defaultBuildVariables as hasuraCommonBuildVariables,
  // defaultGetResponseParser as hasuraParser,
} from './hasura/index';
// import { HttpError } from 'react-admin';
import { ApolloClient, createHttpLink, InMemoryCache, ApolloLink } from '@apollo/client';
import customBuildFields from './customFields'
import customBuildVariables, { directVariables } from './customVariables';

// docs: https://github.com/hasura/ra-data-hasura
const hasuraProvider = async () => {
  const strConn = (process.env.REACT_APP_API_URL || '') + (process.env.REACT_APP_GRAPHQL_SUFFIX || '')
  // console.log(strConn)
  const httpLink = createHttpLink({
    uri: strConn !== '' ? strConn : 'http://127.0.0.1:8080/v1/graphql',
  });


  const authMiddleware = () =>
    new ApolloLink((operation, forward) => {
      const authToken = localStorage.getItem('token');
      // console.log(authToken)
      // add the authorization to the headers
      if (authToken && authToken !== '') {

        operation.setContext({
          headers: {
            authorization: `Bearer ${authToken}`,
          },
        });
      }
      return forward(operation);
    });

  const client = new ApolloClient({
    link: authMiddleware().concat(httpLink),
    cache: new InMemoryCache(),
  });


  const customVariables = (introspectionResults: any) => (
    resource: any,
    aorFetchType: any,
    params: any,
    queryType: any
  ) => {

    let vars: any
    if (directVariables[queryType.name as string] && directVariables[queryType.name as string][aorFetchType]) {
      vars = customBuildVariables(introspectionResults)(
        resource,
        aorFetchType,
        params,
        queryType
      )
    } else {
      vars = hasuraCommonBuildVariables(introspectionResults)(
        resource,
        aorFetchType,
        params,
        queryType
      )

    }
    return vars
  }

  // Including types with a function
  // console.log(process.env.NODE_ENV)
  let dataProvider
  if (process.env.NODE_ENV === 'production') {
    const response = await fetch(process.env.PUBLIC_URL + '/introspection.json')
    const introspection = await response.json()
    dataProvider = await buildHasuraProvider(
      { client, introspection: { schema: introspection.__schema } },
      {
        buildFields: customBuildFields,
      },
      customVariables,
    )
  } else {
    dataProvider = await buildHasuraProvider({ client },
      { buildFields: customBuildFields },
      customVariables,
    )
  }

  // console.log(dataProvider)
  return dataProvider
}

export default hasuraProvider